module.exports = __webpack_public_path__ + "1a4d6659f6fe176ea1df1fb0ffc452e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/business-default-avt.png
// module id = ./assets/images/header/business-default-avt.png
// module chunks = 0